import { render } from "./StatsWidgetDataConfig.vue?vue&type=template&id=b7102a8a"
import script from "./StatsWidgetDataConfig.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetDataConfig.vue?vue&type=script&lang=ts"

import "./StatsWidgetDataConfig.vue?vue&type=style&index=0&id=b7102a8a&lang=scss"
script.render = render

export default script